export default {
  customclass: 'Custom class',
  customclasses: 'Custom classes',
  verbose_customclass: 'a custom class',
};
